import React from 'react';
import {
  hallowGreyCircle,
  hallowRedCircle,
  inProgressLate,
  redCross,
  greenV,
  hallowGreenCircle,
  solidGreenCircle,
  UnallocatedHallowGreyCircle,
  UnallocatedSolidGreenCircle,
  UnallocatedNA,
  NA,
} from "../../ArtworkStatus/constant";

const TableFooter = ({ isSpecialProject }) => {
  return (
    <div className="footerIcons">
      <div className="footerIconsMain footIcon">
        <div>
          <i className="pi pi-check footerIconAll footerIcons3"></i>
        </div>
        <div className="footerIconsContent1">{greenV}</div>
      </div>

      {!isSpecialProject && (
        <div className="footerIconsMain footIcon">
          <div>
            <i className="pi pi-times footerIconAll footerIcons4"></i>
          </div>
          <div className="footerIconsContent1">{redCross}</div>
        </div>
      )}

      {!isSpecialProject && (
        <div className="footerIconsMain footIcon">
          <div>
            <i className="pi pi-circle-off footerIconAll footerIcons5"></i>
          </div>
          <div className="footerIconsContent1">{hallowGreenCircle}</div>
        </div>
      )}

      {!isSpecialProject && (
        <div className="footerIconsMain footIcon">
          <div>
            <i className="pi pi-circle-off footerIconAll footerIcons6"></i>
          </div>
          <div className="footerIconsContent1">
            <span> {hallowRedCircle}</span>
          </div>
        </div>
      )}

      <div className="footerIconsMain footIcon ">
        <div>
          <i className="pi pi-circle-off footerIconAll footerIcons7"></i>
        </div>
        <div className="footerIconsContent1">
          <span>{isSpecialProject ? UnallocatedHallowGreyCircle : hallowGreyCircle}</span>
        </div>
      </div>

      <div className="footerIconsMain footIcon">
        <div>
          <i className="pi pi-circle-on footerIconAll footerIcons8"></i>
        </div>
        <div className="footerIconsContent1">
          <span style={{ paddingTop: "10px" }}>
            {isSpecialProject ? UnallocatedSolidGreenCircle : solidGreenCircle}
          </span>
        </div>
      </div>

      {!isSpecialProject && (
        <div className="footerIconsMain footIcon">
          <div>
            <i className="pi pi-circle-on footerIconAll footerIcons9"></i>
          </div>
          <div className="footerIconsContent1">
            <span>{inProgressLate}</span>
          </div>
        </div>
      )}

      <div className="footerIconsMain footIcon">
        <div className="footerIcons10 footerIconAll">
          <span>2/1/0</span>
        </div>
        <div className="footerIconsContent1">
          <span>Approvers / Approved / Rejected</span>
        </div>
      </div>

      <div className="footerIconsMain footIcon">
        <div className="footerIcons11 footerIconAll">
          <span>N/A</span>
        </div>
        <div className="footerIconsContent1">
          <span>{isSpecialProject ? UnallocatedNA : NA}</span>
        </div>
      </div>
    </div>
  );
};

export default TableFooter;
